export default __webpack_public_path__ + "static/media/car.f61e6b09.svg";